import { SwiperSlide } from "swiper/react";

import styles from "./AboutPros.module.scss";
import { generateMediaQuery } from "../../shared/lib/helpers";
import { MediaQueryProperty, MediaSizeEnum } from "../../shared/constants/media";
import { useMediaQuery } from "../../shared/hooks/useMediaQuery";
import { Carousel, Container } from "../../shared/ui";
import { prosData, swiperMobileProps } from "./const";
import { CardPros } from "../CollectionPros/ui/CardPros";
import type { FC, CSSProperties } from "react";

const mediaQuery = generateMediaQuery(MediaQueryProperty.MaxWidth, MediaSizeEnum.sm);

const listPros = prosData.map((data, index) => (
    <SwiperSlide key={index} className={styles.slide}>
        <CardPros {...data} className={styles.card} />
    </SwiperSlide>
));

export const AboutPros: FC = () => {
    const isMobile = useMediaQuery(mediaQuery);

    return (
        <div className={styles.wrapper}>
            <div className={styles.scroll} id="achievements" />
            <Container marginSize={!isMobile ? "standard" : undefined} className={styles.content}>
                <Carousel
                    className={styles.carousel}
                    loop={false}
                    spaceBetween={isMobile ? 0 : 20}
                    slidesOffsetBefore={isMobile ? 20 : 0}
                    slidesOffsetAfter={isMobile ? 20 : 0}
                    {...swiperMobileProps}
                    style={{ "--space-between-slide": isMobile ? "0" : "20px" } as CSSProperties}
                >
                    {listPros}
                </Carousel>
            </Container>
        </div>
    );
};

export default AboutPros;
